import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import "./book-session-button.scss";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { ButtonLink } from "../../../../../../components/inputs/button-link/button-link";
import rmsMixpanelStore from "../../../../../../stores/rms-mixpanel-store";
import ResolveCapability from "../../../../../../components/resolve-capability/resolve-capability";
import { PROFILE_CAPABILITIES } from "../../../../../../models/ProfileCapabilities";

const BookSessionButton: React.FC = () => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-home';
    return (
		<ResolveCapability capability={PROFILE_CAPABILITIES.SUPPORT}>
			{({ allowOnboardingCallBooking }) => allowOnboardingCallBooking && (
				<div className="book-session-button">
					<FontBody1>
						{getTranslation('SCHEDULE_VIDEO_WITH_SUPPORT', scope)}
					</FontBody1>
					{/* @TODO
		                find a better way to solve this problem

		                we need this span because otherwise the button takes 100% of the space
		                and we need it to take the space by it's content

		                Few alternatives:
		                1. create inline-layout which has `max-width: fit-content;`
		                2. extend ButtonLink somehow to support 2 modes - width: 100% and width: fit-content
		                3. override via CSS in styles, like `& > a { max-width: fit-content; }`
		            */}
					<span onClick={() => rmsMixpanelStore.trackEvent('d&_home_help_book_session')}>
		                <ButtonLink target="_blank" href="https://returngo.ai/go/onboarding-session" text={getTranslation('BOOK_SESSION', scope)} />
		            </span>
				</div>
			)}
		</ResolveCapability>
    )
};

export default BookSessionButton;
